<div style="position: relative; display: flex; align-items: center; justify-content: center;">
    @if (value() > 0) {
    <p-badge class="overlay-badge" [value]="value()" [@pulse]="pulse()"></p-badge>
    }

    <ng-content></ng-content>
</div>